export interface ExerciserReviewedInterface {
  reviewed?: boolean
  submitted?: boolean
}

export class ExerciserReviewed implements ExerciserReviewedInterface {
  reviewed?: boolean
  submitted?: boolean

  constructor(props: ExerciserReviewedInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      reviewed: _reviewed,
      submitted: _submitted,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.reviewed = _reviewed
    this.submitted = _submitted
  }
}
